import { getAllProfilesRequest, getProfileRequest,  addProfileRequest, updateProfileRequest, deleteProfileRequest} from "./api-request-builders/money-machine-manager-request.builder";
import { TraceLoggingHelpers } from "./models/helpers/trace-logging-helpers";

export class MoneyMachineManagerClient {
    
    private profileUnsubscribeWithCancelTokenCallback: any = null;

    constructor() {
    }

    public getAllProfiles(setResponseOnDataCallback: Function) {
        this.unsubscribe();

        this.profileUnsubscribeWithCancelTokenCallback = getAllProfilesRequest((response: string) => {
            setResponseOnDataCallback(response);
        });
    }

    public getProfile(profileId: string, setResponseOnDataCallback: Function) {
        this.unsubscribe();

        this.profileUnsubscribeWithCancelTokenCallback = getProfileRequest(profileId, (response: string) => {
            setResponseOnDataCallback(response);
        });
    }

    public addProfile(broker: string, userAccountId: string, profileName: string, profileDescription: string, profileDefault: boolean, settings: string, setResponseOnDataCallback: Function) {
        this.unsubscribe();

        this.profileUnsubscribeWithCancelTokenCallback = addProfileRequest(broker, userAccountId, profileName, profileDescription, profileDefault, settings, (response: string) => {
            setResponseOnDataCallback(response);
        });
    }

    public updateProfile(profileId: string, broker: string, userAccountId: string, profileName: string, profileDescription: string, profileDefault: boolean, settings: string, setResponseOnDataCallback: Function) {
        this.unsubscribe();

        this.profileUnsubscribeWithCancelTokenCallback = updateProfileRequest(profileId, broker, userAccountId, profileName, profileDescription, profileDefault, settings, (response: string) => {
            setResponseOnDataCallback(response);
        });
    }

    public deleteProfile(profileId: string, setResponseOnDataCallback: Function) {
        this.unsubscribe();

        this.profileUnsubscribeWithCancelTokenCallback = deleteProfileRequest(profileId, (response: string) => {
            setResponseOnDataCallback(response);
        });
    }

    public unsubscribe() {
        TraceLoggingHelpers.log('unsubscribe ', this.profileUnsubscribeWithCancelTokenCallback)
        if (this.profileUnsubscribeWithCancelTokenCallback) {
            this.profileUnsubscribeWithCancelTokenCallback();
            this.profileUnsubscribeWithCancelTokenCallback = null;
        }
    }
}
